/* jshint esversion: 6 */

import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

const IS_DEV = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname === '0.0.0.0');
const BASEPATH = (window.location.hostname === '0.0.0.0' ? './img/store-locator/' : '/Modules/StoreLocator/docs/img/store-locator/');

const GTM_CAT = 'store-locator';
const ZOOM_LEVEL = 13;
const SHOW_INFO_WINDOW = false;
const MAX_DISTANCE = 100;
let GOOGLE_MAPS = null;

// mercati "sbloccati" per gli agenti: Italia (IT), Francia (FR), Germania (DE), Belgio (BE), Austria (AT)
const agentsEnabledCountry = ['IT', 'FR', 'DE', 'BE', 'AT'];

const continentAmerica = { //see https://gist.github.com/nobuti/3816985 and https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
	"AI": "North America", // "Anguilla")
	"AG": "North America", // "Antigua and Barbuda")
	"AR": "South America", // "Argentine Republic")
	"AW": "North America", // "Aruba")
	"BS": "North America", // "Commonwealth of the Bahamas")
	"BB": "North America", // "Barbados")
	"BZ": "North America", // "Belize")
	"BM": "North America", // "Bermuda")
	"BO": "South America", // "Plurinational State of Bolivia")
	"BQ": "North America", // '535'
	"BR": "South America", // "Federative Republic of Brazil")
	"VG": "North America", // "British Virgin Islands")
	"CA": "North America", // "Canada")
	"KY": "North America", // "Cayman Islands")
	"CL": "South America", // "Republic of Chile")
	"CO": "South America", // "Republic of Colombia")
	"CR": "North America", // "Republic of Costa Rica")
	"CU": "North America", // "Republic of Cuba")
	"CW": "North America", // "Curaçao")
	"DM": "North America", // "Commonwealth of Dominica")
	"DO": "North America", // "Dominican Republic")
	"EC": "South America", // "Republic of Ecuador")
	"SV": "North America", // "Republic of El Salvador")
	"FK": "South America", // "Falkland Islands (Malvinas)")
	"GF": "South America", // "French Guiana")
	"GL": "North America", // "Greenland")
	"GD": "North America", // "Grenada")
	"GP": "North America", // "Guadeloupe")
	"GT": "North America", // "Republic of Guatemala")
	"GY": "South America", // "Co-operative Republic of Guyana")
	"HT": "North America", // "Republic of Haiti")
	"HN": "North America", // "Republic of Honduras")
	"JM": "North America", // "Jamaica")
	"MQ": "North America", // "Martinique")
	"MX": "North America", // "United Mexican States")
	"MS": "North America", // "Montserrat")
	"NI": "North America", // "Republic of Nicaragua")
	"PA": "North America", // "Republic of Panama")
	"PY": "South America", // "Republic of Paraguay")
	"PE": "South America", // "Republic of Peru")
	"PR": "North America", // "Commonwealth of Puerto Rico")
	"BL": "North America", // "Saint Barthélemy")
	"KN": "North America", // "Federation of Saint Kitts and Nevis")
	"LC": "North America", // "Saint Lucia")
	"MF": "North America", // "Saint Martin (French part)")
	"PM": "North America", // "Saint Pierre and Miquelon")
	"VC": "North America", // "Saint Vincent and the Grenadines")
	"SX": "North America", // "Sint Maarten (Dutch part)")
	"SR": "South America", // "Republic of Suriname")
	"TT": "North America", // "Republic of Trinidad and Tobago")
	"TC": "North America", // "Turks and Caicos Islands")
	"US": "North America", // "United States of America")
	"VI": "North America", // "United States Virgin Islands")
	"UY": "South America", // "Eastern Republic of Uruguay")
	"VE": "South America" // "Bolivarian Republic of Venezuela")
}

const ExceptionEdilferrarese = [
	{ k: "VR", v: "Terrazzo" },
	{ k: "VR", v: "Minerbe" },
	{ k: "VR", v: "Bevilacqua" },
	{ k: "VR", v: "Pressana" },
	{ k: "RO", v: "Giacciano con Baruchella" },
	{ k: "RO", v: "Badia Polesine" },
	{ k: "RO", v: "Lendinara" },
	{ k: "VR", v: "Roveredo di Guà" },
	{ k: "VI", v: "Poiana maggiore" },
	{ k: "VI", v: "Sossano" },
	{ k: "VI", v: "Campiglia dei Berici" },
	{ k: "VI", v: "Noventa Vicentina" },
	{ k: "VI", v: "Agugliaro" },
	{ k: "VI", v: "Villaga" },
	{ k: "VI", v: "Albettone" },
	{ k: "VI", v: "Barbarano Vicentino" },
	{ k: "VI", v: "Mossano" },
	{ k: "VI", v: "Nanto" },
	{ k: "VI", v: "Castegnero" },
	{ k: "RO", v: "Villanova del Ghebbo" },
	{ k: "RO", v: "Lusia" },
	{ k: "RO", v: "Rovigo" },
	{ k: "RO", v: "Ceregnano" },
	{ k: "RO", v: "Villadose" },
	{ k: "RO", v: "San Martino di Venezze" },
	{ k: "VI", v: "Montegaldella" },
	{ k: "VI", v: "Longare" },
	{ k: "VI", v: "Torri di Quartesolo" },
	{ k: "VI", v: "Montegalda" },
	{ k: "VI", v: "Grumolo delle Abbadesse" },
	{ k: "VI", v: "Grisignano di Zocco" },
	{ k: "VI", v: "Camisano Vicentino" },
	{ k: "VI", v: "Quinto Vicentino" },
	{ k: "VI", v: "Bolzano Vicentino" },
	{ k: "VI", v: "Sandrigo" },
	{ k: "VI", v: "Bressanvido" },
	{ k: "VI", v: "Pozzoleone" },
	{ k: "VI", v: "Tezze sul Brenta" },
	{ k: "TV", v: "Castello di Godego" },
	{ k: "TV", v: "Castelfranco Veneto" },
	{ k: "VI", v: "Rossano Veneto" },
	{ k: "TV", v: "Loria" },
	{ k: "RO", v: "Pettorazza Grimani" },
	{ k: "RO", v: "Adria" },
	{ k: "VE", v: "Cavarzere" },
	{ k: "VE", v: "Cona" },
	{ k: "VE", v: "Campolongo Maggiore" },
	{ k: "RO", v: "Loreo" },
	{ k: "RO", v: "Rosolina" },
	{ k: "VE", v: "Campagna Lupia" },
	{ k: "VE", v: "Chioggia" },
	{ k: "VE", v: "Vigonovo" },
	{ k: "VE", v: "Stra" },
	{ k: "VE", v: "Fiesso d'Artico" },
	{ k: "VE", v: "Pianiga" },
	{ k: "VE", v: "Santa Maria di Sala" },
	{ k: "VE", v: "Fossò" },
	{ k: "VE", v: "Dolo" },
	{ k: "VE", v: "Camponogara" },
	{ k: "VE", v: "Mirano" },
	{ k: "TV", v: "Resana" },
	{ k: "TV", v: "Vedelago" },
	{ k: "VE", v: "Noale" },
	{ k: "VE", v: "Salzano" },
	{ k: "TV", v: "Morgano" },
	{ k: "TV", v: "Istrana" },
	{ k: "VE", v: "Mira" },
	{ k: "VE", v: "Spinea" },
	{ k: "VE", v: "Venezia" },
	{ k: "VE", v: "Martellago" },
	{ k: "VE", v: "Scorzè" },
	{ k: "TV", v: "Zero branco" }
]

export const ITEMS_PER_PAGE = 6;

class StoreLocatorCtrl {

	constructor(
		$scope,
		$timeout,
		DomService,
		ApiService
	) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.domService = DomService;
		this.apiService = ApiService;
		if (!window.storeLocatorSettings.apiKey && !IS_DEV) {
			throw (`Missing Google Map Api Key`);
		}
		this.apiKey = window.storeLocatorSettings.apiKey;
		this.model = {};
		this.busyFind = false;
		this.busyLocation = false;
		this.busyCity = false;
		this.busyInfoAgents = false;
		this.requiredAddress = false;
		//this.$timeout(() => {
		//	angular.element('#address-input').addClass('disabled');
		//	angular.element('#address-input input').attr('disabled', true);
		//	angular.element('#address-input input').attr('readonly', true);
		//}, 500);
		this.maxSearch = 3;
		this.countSearch = 0;
		this.searchCountry = "";
		this.visibleStores = []; // non si usa più --> visibleItems
		this.visibleAgents = [];
		this.searchProvinceCode = "";
		this.searchCity = "";
		this.searchArea = "";
		this.mapCenter$ = new Subject();
		this.labels = window.labels || {
			approximately: window.storeLocatorSettings.localizedStrings.LBL_DISTANZA_STORE,
			moreInfo: `More Info`,
			reachStore: window.storeLocatorSettings.localizedStrings.LBL_RAGGIUNGERE_STORE,
			contactStore: window.storeLocatorSettings.localizedStrings.LBL_CONTATTA_STORE,
			contactAgent: window.storeLocatorSettings.localizedStrings.LBL_CONTATTA_AGENTE
		};
		if (GOOGLE_MAPS !== null) {
			this.initMap();
		} else {
			window.onGoogleMapsLoaded = () => {
				GOOGLE_MAPS = google.maps;
				this.initMap();
			};
			const script = document.createElement('script');
			script.setAttribute('type', 'text/javascript');
			script.setAttribute('src', `https://maps.googleapis.com/maps/api/js?callback=onGoogleMapsLoaded${this.apiKey ? `&key=${this.apiKey}` : ''}&libraries=places&language=${$('html').attr('lang')}`);
			(document.getElementsByTagName('head')[0] || document.documentElement).appendChild(script);
		}

		this.unsubscribe = new Subject();
		this.mapCenter$.pipe(
			debounceTime(1000),
			takeUntil(this.unsubscribe)
		).subscribe(position => {
			this.$timeout(() => {
				this.visibleItems = this.getStoresByViewport();
			}, 1);
		});
		$scope.$on('destroy', () => {
			this.unsubscribe.next();
			this.unsubscribe.complete();
		});
	}

	initMap() {
		const mapOptions = {
			zoom: 17,
			center: new google.maps.LatLng(44.5416713, 10.8259022), // prima ricerca vicino a casa madre
			styles: [
				{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#e9e9e9"
						},
						{
							"lightness": 17
						}
					]
				},
				{
					"featureType": "landscape",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f5f5f5"
						},
						{
							"lightness": 20
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#ffffff"
						},
						{
							"lightness": 17
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#ffffff"
						},
						{
							"lightness": 29
						},
						{
							"weight": 0.2
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#ffffff"
						},
						{
							"lightness": 18
						}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#ffffff"
						},
						{
							"lightness": 16
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f5f5f5"
						},
						{
							"lightness": 21
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#dedede"
						},
						{
							"lightness": 21
						}
					]
				},
				{
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"visibility": "on"
						},
						{
							"color": "#ffffff"
						},
						{
							"lightness": 16
						}
					]
				},
				{
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"saturation": 36
						},
						{
							"color": "#333333"
						},
						{
							"lightness": 40
						}
					]
				},
				{
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f2f2f2"
						},
						{
							"lightness": 19
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#fefefe"
						},
						{
							"lightness": 20
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#fefefe"
						},
						{
							"lightness": 17
						},
						{
							"weight": 1.2
						}
					]
				}
			]
		};
		const mapElement = document.getElementById('map');
		if (!mapElement) {
			return;
		}
		const map = new google.maps.Map(mapElement, mapOptions);

		var startingMapBounds;

		if (window.storeLocatorSettings.currMkt === 2) {
			startingMapBounds = this.getItalyBounds();
		} else {
			startingMapBounds = this.getWorldBounds();
		}

		map.fitBounds(startingMapBounds);

		map.addListener('bounds_changed', () => {
			const position = map.getCenter();
			this.mapCenter$.next(position);
			this.visibleItems = this.getStoresByViewport();
		});

		this.position = mapOptions.center;
		this.$timeout(() => {
			this.map = map;
			window.gmap = map;
		});

		let autocompleteUnique = new google.maps.places.Autocomplete(document.querySelector('#cities-input input'));
		document.querySelector('#cities-input input').addEventListener('keydown', (e) => {
			this.model.address = undefined;
			this.busyCity = false;
		}, false);
		google.maps.event.addListener(autocompleteUnique, 'place_changed', () => {
			var city = autocompleteUnique.getPlace();
			var filteredInfoCity = [];
			if (city.address_components !== undefined) {
				filteredInfoCity = city.address_components.filter(function (address_component) {
					return address_component.types.includes("country");
				});
			}

			// Task ID 54776 CDE - ULTERIORI INTERVENTI RICHIESTI X STORE LOCATOR --> Messaggio da lasciare fisso, non più "bloccante" per l'Italia ---
			// per l'Italia controllo se c'è il dato che serve a me tra i livelli (indirizzo con almeno la via
			// se poi non lo trovo faccio lo show del messaggio per richiedere anche l'indirizzo, nel caso italiano
			//var country = filteredInfoCity.length ? filteredInfoCity[0].short_name : '';
			//this.requiredAddress = country === 'IT' ? true : false;
			//if (this.requiredAddress) {
			//	var address = [];
			//	if (city.address_components !== undefined) {
			//		address = city.address_components.filter(function (address_component) {
			//			return address_component.types.includes("route");
			//		});
			//	}

			//	if (address.length !== 0) {
			//		this.model.address = angular.element('#cities-input input').val();
			//		$("#errorNotes").hide();
			//	}
			//	else {
			//		//$("#errorNotes").html('*Complete address is required for this country!');
			//		$("#errorNotes").show();
			//	}
			//}
			// ----------------------------------------------------------------------------------------------------------------------------------------
			//if (country === 'IT') {
			//	this.model.address = city.formatted_address;
			//}

			this.busyCity = true;
		});
		document.querySelector('#cities-input input').addEventListener('blur', () => {
			const geocoder = this.geocoder || new google.maps.Geocoder();
			this.geocoder = geocoder;
			geocoder.geocode({ address: this.model.city }, (results, status) => {
				if (status == 'OK') {
					var filteredInfoCity = results[0].address_components.filter(function (address_component) {
						return address_component.types.includes("country");
					});


					// Task ID 54776 CDE - ULTERIORI INTERVENTI RICHIESTI X STORE LOCATOR --> Messaggio da lasciare fisso, non più "bloccante" per l'Italia ---
					//var country = filteredInfoCity.length ? filteredInfoCity[0].short_name : '';
					//this.requiredAddress = country === 'IT' ? true : false;
					//if (this.requiredAddress) {
					//	var city = autocompleteUnique.getPlace();
					//	var address = [];
					//	if (city.address_components !== undefined) {
					//		address = city.address_components.filter(function (address_component) {
					//			return address_component.types.includes("route");
					//		});
					//	}

					//	 Task ID 54776 CDE - ULTERIORI INTERVENTI RICHIESTI X STORE LOCATOR --> Messaggio da lasciare fisso, non più "bloccante" per l'Italia
					//	if (address.length !== 0) {
					//		this.model.address = angular.element('#cities-input input').val();
					//		$("#errorNotes").hide();
					//	}
					//	else {
					//		//$("#errorNotes").html('*Complete address is required for this country!');
					//		$("#errorNotes").show();
					//	}
					//}
					// ----------------------------------------------------------------------------------------------------------------------------------------
					this.busyCity = true;
					this.$scope.$apply();
				}
			});
		});

		this.loadAllStores();
		this.loadAllAgents();
	}

	calculateDistance(lat1, lon1, lat2, lon2, unit) {
		if ((lat1 == lat2) && (lon1 == lon2)) {
			return 0;
		} else {
			const radlat1 = Math.PI * lat1 / 180;
			const radlat2 = Math.PI * lat2 / 180;
			const theta = lon1 - lon2;
			const radtheta = Math.PI * theta / 180;
			let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
			if (dist > 1) {
				dist = 1;
			}
			dist = Math.acos(dist);
			dist = dist * 180 / Math.PI;
			dist = dist * 60 * 1.1515;
			if (unit == "K") {
				dist = dist * 1.609344;
			}
			if (unit == "N") {
				dist = dist * 0.8684;
			}
			return dist;
		}
	}

	clearMarkers() {
		if (this.markerCluster) {
			this.markerCluster.clearMarkers();
		}

		for (let i = 0; i < this.stores.length; i++) {
			if (this.stores[i].marker) {
				this.stores[i].marker.setMap(null);
				this.stores[i].marker = null;
			}
		}

		if (this.markerAgentCluster) {
			this.markerAgentCluster.clearMarkers();
		}

		for (let i = 0; i < this.agents.length; i++) {
			if (this.agents[i].marker) {
				this.agents[i].marker.setMap(null);
				this.agents[i].marker = null;
			}
		}
	}

	addMarkers(stores) {
		const markers = stores.map((store) => {
			const position = new google.maps.LatLng(store.latitude, store.longitude);
			let content = `<div class="marker__content">
				<div class="title"><span>${store.title}</span></div>
				<div class="group group--info">
					<div class="address">
						${store.address}<br>
						${store.zip} ${store.city} ${store.provinceCode} ${store.countryCode}<br>
						${store.telephone ? `<span><a href="tel:${store.telephone}">${store.telephone}</a><br></span>` : ''}
						${store.website ? `<span><a target="_blank" href="${store.website}">${store.website}</a></span>` : ''}
					</div>
					${store.address !== '' ? `<div class="distance">${this.labels.approximately} <b>${Math.floor(store.distance)} km</b></div>` : ``}
				</div>
				<div class="group group--cta">
					${store.address !== '' ? `<a id="locator-marker" href="https://www.google.it/maps/dir/${position.lat()},${position.lng()}/${store.title}/@${store.latitude},${store.longitude}/" target="_blank" class="btn btn--link"><span>${this.labels.reachStore}</span></a>` : ``}
				</div>
			</div>`;

			const icon = ['pin-reseller.png','pin-top-store.png', 'pin-top-store.png', 'pin-reseller.png', 'pin-showroom.png'][11 - store.type];

			let marker = new google.maps.Marker({
				position: position,
				// map: this.map,
				icon: `${BASEPATH}${icon}`,
				title: store.title,
				store: store,
				content: content,
			});
			marker.addListener('click', () => {
				this.setMarkerWindow(marker.position, content);
				this.scrollToStore(store);
				// GtmService.push({ event: 'dealerlocator', action: 'marker-click', label: store.title });
			});
			store.marker = marker;
			return marker;
		});

		const markerCluster = new MarkerClusterer(this.map, markers, {
			imagePath: `${BASEPATH}cluster-`,
		});
		const styles = markerCluster.getStyles();
		styles.forEach(style => style.textColor = '#ffffff');
		markerCluster.setStyles(styles);
		this.markers = markers;
		this.markerCluster = markerCluster;
	}

	addAgentsMarkers(agents) {
		const markers = agents.map((agent) => {
			//console.log('agent.latitude ', agent.latitude, ' agent.longitude ', agent.longitude, ' this.position.lat() ', this.position.lat(), ' this.position.lng() ', this.position.lng());
			const position = new google.maps.LatLng(agent.latitude === null ? this.position.lat() : agent.latitude, agent.longitude === null ? this.position.lng() : agent.longitude);
			let content = `<div class="marker__content">
				<div class="title"><span>${agent.title}</span></div>
				<div class="group group--info">
					<div class="address">
						${agent.address ? `${agent.address}` : ''}<br>
						${agent.zip ? `${agent.zip}` : ''} ${agent.city ? `${agent.city}` : ''} ${agent.province ? `${agent.province}` : ''} ${agent.countries}<br>
						${agent.telephone ? `<span><a href="tel:${agent.telephone}">${agent.telephone}</a><br></span>` : ''}
					</div>
				</div>
			</div>`;

			const icon = 'pin-reseller.png';

			let marker = new google.maps.Marker({
				position: position,
				// map: this.map,
				icon: `${BASEPATH}${icon}`,
				title: agent.title,
				store: agent,
				content: content,
			});
			marker.addListener('click', () => {
				this.setMarkerWindow(marker.position, content);
				//this.scrollToStore(store);
				// GtmService.push({ event: 'dealerlocator', action: 'marker-click', label: store.title });
			});
			agent.marker = marker;
			return marker;
		});

		const markerCluster = new MarkerClusterer(this.map, markers, {
			imagePath: `${BASEPATH}cluster-`,
		});
		const styles = markerCluster.getStyles();
		styles.forEach(style => style.textColor = '#ffffff');
		markerCluster.setStyles(styles);
		this.markers = markers;
		this.markerAgentCluster = markerCluster;
	}

	goToMap() {
		var map = document.getElementById("mappa");
		map.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}

	getGeolocation(map) {
		this.error = null;
		this.busyLocation = true;
		let position = this.map.getCenter();

		// Try HTML5 geolocation.
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition((location) => {
				position = new google.maps.LatLng(location.coords.latitude, location.coords.longitude);

				const geocoder = this.geocoder || new google.maps.Geocoder();
				this.geocoder = geocoder;
				geocoder.geocode({ 'location': position }, (results, status) => {
					if (status == 'OK') {
						var filteredInfoCity = results.filter(function (address_component) {
							return address_component.types.includes("locality");
						});
						this.model.city = filteredInfoCity.length ? filteredInfoCity[0].formatted_address : undefined;
						this.model.address = results[0].formatted_address;

						for (let i = 0; i < results[0].address_components.length; i++) {
							if (results[0].address_components[i].types[0] == "country" || results[0].address_components[i].types[0] == "political") {
								this.searchCountry = results[0].address_components[i].short_name;
							}
						}

						this.setInfoWindow(position, 1);
						this.searchPosition(position).finally(() => this.busyLocation = false);
						this.map.setCenter(position);
						this.map.setZoom(ZOOM_LEVEL);
					}
				});
			}, () => {
				this.setInfoWindow(position, 2);
				this.searchPosition(position).finally(() => this.busyLocation = false);
			});
		} else {
			// Browser doesn't support Geolocation
			this.setInfoWindow(position, 3);
			this.searchPosition(position).finally(() => this.busyLocation = false);
		}
	}

	loadAllStores() {
		//if (this.stores) {
		//	return Promise.resolve(this.stores);
		//}
		// this.loadFakeStores();
		const isStatic = false;
		return this.apiService.storeLocator.all(isStatic).then(success => {
			const stores = success.data.d.storeList; //success.data; // success.data.d.storeList;
			stores.forEach(store => store.distance = this.position ? this.calculateDistance(store.latitude, store.longitude, this.position.lat(), this.position.lng(), 'K') : '');

			this.visibleItems = [];
			this.maxItems = ITEMS_PER_PAGE;
			this.stores = stores;
			this.visibleItems = this.getStoresByViewport();

			return stores;
		});
	}

	loadAllAgents() {
		if (this.agents) {
			return Promise.resolve(this.agents);
		}
		const isStatic = false;
		return this.apiService.agentLocator.all().then(success => {
			const agents = success.data.d.agentList;

			this.agents = agents;

			return agents;
		});
	}

	loadFakeStores() {
		return fetch(`https://maps.googleapis.com/maps/api/place/findplacefromtext/json?input=Ceramiche&inputtype=textquery&fields=name,formatted_address,address_components,formatted_phone_number,geometry${this.apiKey ? `&key=${this.apiKey}` : ''}`, { mode: 'cors' }).then(response => {
			return response.json();
		}).then(json => {
			console.log('json', json);
			return json.candidates.map((x, i) => {
				return {
					id: i + 1,
					latitude: x.geometry.location.lat,
					longitude: x.geometry.location.lng,
					title: x.name,
					address: x.formatted_address,
					type: 1 + Math.floor(Math.random() * 3)
				}
			});
			/*
			{
				id: 2,
				latitude: 44.5902807,
				longitude: 10.721454,
				title: 'Lea Ceramiche',
				abstract: 'Negozio di piastrelle ceramiche',
				address: 'Via Statale, 127',
				zip: '42013',
				city: 'Casalgrande',
				province: 'Reggio Emilia',
				provinceCode: 'RE',
				country: 'Italia',
				countryCode: 'IT',
				telephone: '+39 0536 837811',
				email: 'info@ceramichelea.it',
				website: 'https://www.ceramichelea.it/',
				image: './img/store-locator/02@2x.jpg',
				type: 3
			}
			*/
		});
	}

	fitBounds(stores) {
		if (stores.length) {
			const bounds = new google.maps.LatLngBounds();
			stores.forEach((store) => {
				const position = new google.maps.LatLng(store.latitude, store.longitude);
				bounds.extend(position);
			});
			this.map.fitBounds(bounds);
			return bounds;
			// console.log('fitBounds');
		}
	}

	findNearStores(stores, position) {
		// non usata
		if (stores) {
			stores.forEach((store) => {
				store.distance = this.calculateDistance(store.latitude, store.longitude, position.lat(), position.lng(), 'K');
				store.visible = (store.cod_stato == window.userCountry || !window.userCountry) && store.distance <= MAX_DISTANCE /* Km */ ;
				if (store.visible) {
					if (store.removed) this.markerCluster.addMarker(store.marker);
					delete store.removed;
				} else {
					this.markerCluster.removeMarker(store.marker);
					store.removed = true;
				}
			});
			stores = stores.slice();
			stores.sort((a, b) => {
				//return a.distance * (a.importante ? 0.5 : 1) - b.distance * (b.importante ? 0.5 : 1);
				return a.distance - b.distance;
			});
			const visibleStores = stores.filter(store => store.visible).slice(0, 50);
			this.$timeout(() => {
				this.visibleItems = visibleStores;
			}, 1);
			// console.log('findNearStores', visibleStores);
			return visibleStores;
		}
	}

	searchPosition(position, viewport) {
		/*		
		Task ID 54776 CDE - ULTERIORI INTERVENTI RICHIESTI X STORE LOCATOR --> Recap regole di funzionamento
		Paesi attivi con rivenditori: Italia, Francia, Germania, Austria e Belgio.

		- Per Italia, Francia, Germania, Austria la visualizzazione della ricerca sul sito avviene secondo queste regole:
			- Massimo 3 rivenditori visualizzati;
			- Raggio di 30 Km dal punto inserito;
			- Insieme ai rivenditori compare sempre l’agente di zona;
			- Se non ci sono rivenditori nel raggio di 30 Km compare solo l’agente;
			- Se non ci sono rivenditori e agente compaiono i dati della Cotto d’Este;
			- Showroom Milano ha come zona la Lombardia;
			- Il rivenditore EDILFERRARESE sarà l’unico a comparire nella sua zona d’esclusiva (Provincia di Padova più alcuni comuni di confine);
			- Se la ricerca avviene vicino al confine di stato, NON devono apparire i rivenditori degli altri stati.
		- Per Belgio la visualizzazione sarà sempre con tutti i rivenditori senza l’agente di zona, perciò decadono le regole di massimo 3 rivenditori e raggio di 30 Km.
		 */


		this.position = position;
		this.viewport = viewport;
		this.map.setCenter(position);
		this.map.setZoom(ZOOM_LEVEL);
		this.setInfoWindow(position, 1);

		return this.loadAllStores().then(success => {
			this.clearMarkers();
			this.closeMarkerWindow();

			this.stores.forEach(store => store.distance = this.position ? this.calculateDistance(store.latitude, store.longitude, this.position.lat(), this.position.lng(), 'K') : '');
			this.stores = this.stores.sort((a, b) => {
				//if (a.type === b.type) {
					return a.distance - b.distance;
				//} else {
				//	return a.type - b.type;
				//}
			});

			if (continentAmerica[this.searchCountry] === undefined) {
				//Ricerca negli altri continenti
				if (this.countryContainsStores(this.searchCountry)) {
					let searchProvinceCode = this.searchProvinceCode;
					let searchCity = this.searchCity;
					var checkExceptionEdilferrarese = _.filter(ExceptionEdilferrarese, function (o) { return o.k === searchProvinceCode && o.v.toLowerCase() === searchCity.toLowerCase(); });
					//console.log('checkExceptionEdilferrarese ', checkExceptionEdilferrarese);
					if (checkExceptionEdilferrarese.length > 0 || searchProvinceCode === 'PD') {
						//Siamo nel caso in cui è statà ricercata una località in esclusiva per lo store Edilferrarese
						var storesByCountry = this.getStoresByCountry(this.searchCountry);
						this.visibleAgents = this.getAgentsByInfo(this.searchCountry);
						let storeEdilferrarese = _.filter(storesByCountry, function (o) { return o.id === 338 || o.email === "info@edilferrarese.it"; });
						if (storeEdilferrarese.length > 0) {
							this.addMarkers(storeEdilferrarese);
						}

						// Cerco i pin in un raggio di 30Km, eventualmente lo estendo se non c'è nulla
						for (let searchRadius = 30000; searchRadius <= 600000; searchRadius += 30000) {
							var searchBounds = new google.maps.Circle({ center: position, radius: searchRadius }).getBounds();

							if (this.boundsContainsStores(searchBounds)) {
								break;
							}
						}
						if (searchBounds) {
							this.map.fitBounds(searchBounds, 0);
							this.map.panToBounds(searchBounds);
						}
					}
					else
					{
						// Vengono aggiunti solo i marker del paese ricercato.
						var storesByCountry = this.getStoresByCountry(this.searchCountry);
						this.visibleAgents = this.getAgentsByInfo(this.searchCountry);
						//console.log('#1 this.searchCountry ', this.searchCountry, ' storesByCountry ', storesByCountry, ' this.visibleAgents ', this.visibleAgents);

						// Per il Belgio non vanno filtrati gli store, li vogliono vedere tutti - Task ID 44539 commento #87
						if (this.searchCountry !== 'BE') {
							if (storesByCountry.length > 3) {
								storesByCountry = storesByCountry.filter(function (store) {
									//	console.log('store ', store);
									if (store.type !== 7) {
										return store.distance <= 30; // mostro solo gli store entro 30km (prima era 150)
									}
								}).slice(0, 3);
							}
						}

						this.addMarkers(storesByCountry);

						//this.$timeout(() => {
						//	if (this.visibleAgents.length > 0) {
						//		this.addAgentsMarkers(this.visibleAgents);
						//	}
						//}, 700);

						// 2a. PER DECIDERE LO ZOOM
						if (this.searchCountry !== 'BE') {
							// Cerco i pin da mostrare in un raggio di 30Km, eventualmente lo estendo se non c'è nulla.
							for (let searchRadius = 30000; searchRadius <= 600000; searchRadius += 30000) {
								var searchBounds = new google.maps.Circle({ center: position, radius: searchRadius }).getBounds();

								if (this.boundsContainsStores(searchBounds)) {
									break;
								}
							}
							if (searchBounds) {
								this.map.fitBounds(searchBounds, 0);
								this.map.panToBounds(searchBounds);
							}
						}
						else {
							// Se è Belgio, voglio mostrare tutti i pin con lo zoom adatto
							if (storesByCountry && storesByCountry.length > 0) {
								var bounds = this.fitBounds(storesByCountry);
								if (bounds) {
									this.map.panToBounds(bounds);
								}
							}
						}
					}
				} else {
					// Se non ci sono store nel paese ricercato allora mostro il mondo intero e il PIN Showroom Italia.
					//this.visibleAgents = this.getAgentsByInfo(this.searchCountry);
					//console.log('#2 this.searchCountry ', this.searchCountry, ' this.visibleAgents ', this.visibleAgents);
					//this.$timeout(() => {
					//	//if (this.visibleAgents.length > 0) {
					//	//	this.addAgentsMarkers(this.visibleAgents);
					//	//}
					//	this.map.fitBounds(this.viewport);
					//	this.map.panTo(new google.maps.LatLng(this.position.lat(), this.position.lng()));
					//}, 700);
					this.visibleAgents = this.getAgentsByInfo(this.searchCountry);
					if (this.visibleAgents.length === 0) {
						//Se non ci sono store nel paese ricercato e non c'è neanche un agente di riferimento allora mostro il mondo intero e il PIN Showroom Italia
						let italyMainStore = this.stores[0];
						this.addMarkers([italyMainStore]);

						this.map.fitBounds(this.getWorldBounds());
						this.map.panTo(new google.maps.LatLng(italyMainStore.latitude, italyMainStore.longitude));
						this.setMarkerWindow(italyMainStore.marker.position, italyMainStore.marker.content);
					} else {
						//Se non ci sono store nel paese ricercato ma c'è almeno un agente di riferimento allora mostro solo questi nelle card e gestisco lo zoom sul paese
						this.map.fitBounds(this.viewport);
						this.map.panTo(new google.maps.LatLng(this.position.lat(), this.position.lng()));
					}
				}
			} else {
				//Ricerca nel continente americano
				this.visibleAgents = this.getAgentsByInfo(this.searchCountry);
				//console.log('#3 this.searchCountry ', this.searchCountry, ' this.visibleAgents ', this.visibleAgents);
				//this.$timeout(() => {
				//	if (this.visibleAgents.length > 0) {
				//		this.addAgentsMarkers(this.visibleAgents);
				//	}
				//}, 700);

				this.map.fitBounds(this.getWorldBounds());
				this.map.panTo(new google.maps.LatLng(this.position.lat(), this.position.lng()));
			}

			// const visibleStores = this.findNearStores(stores, position);
			/*
			if (visibleStores) {
				this.fitBounds(visibleStores);
			}
			*/
		});
	}

	panTo(store) {
		const position = new google.maps.LatLng(store.latitude, store.longitude);
		this.map.setZoom(ZOOM_LEVEL);
		this.map.panTo(position);
		const marker = this.markers.find(x => x.store === store);
		this.setMarkerWindow(marker.position, marker.content);
	}

	onSubmit() {
		this.$timeout(() => {
			if (this.busyCity) {
				this.error = null;
				this.busyFind = true;
				/*
				const fakeFilter = {
					'': {
						value: this.model.address,
						options: [
							{
								value: this.model.address,
								key: this.model.address
							}
						]
					}
				};
				GtmService.pageViewFilters(GTM_CAT, fakeFilter);
				*/
				const geocoder = this.geocoder || new google.maps.Geocoder();
				this.geocoder = geocoder;
				geocoder.geocode({ address: this.requiredAddress ? this.model.address : this.model.city }, (results, status) => {
					this.model = {
						city: this.model.city,
						address: this.model.address
					};
					if (status == 'OK') {
						const position = results[0].geometry.location;
						const viewport = results[0].geometry.viewport;
						console.log('results ', results);
						for (let i = 0; i < results[0].address_components.length; i++) {
							if (results[0].address_components[i].types[0] == "country" || results[0].address_components[i].types[0] == "political") {
								this.searchCountry = results[0].address_components[i].short_name;
							}
						}

						for (let i = 0; i < results[0].address_components.length; i++) {
							if (results[0].address_components[i].types[0] == "administrative_area_level_2") {
								this.searchProvinceCode = results[0].address_components[i].short_name;
							}
						}
						for (let i = 0; i < results[0].address_components.length; i++) {
							if (results[0].address_components[i].types[0] == "administrative_area_level_3" || results[0].address_components[i].types[0] == "locality") {
								this.searchCity = results[0].address_components[i].short_name;
							}
						}
						for (let i = 0; i < results[0].address_components.length; i++) {
							if (results[0].address_components[i].types[0] == "administrative_area_level_1") {
								this.searchArea = results[0].address_components[i].short_name;
							}
						}
						//console.log('this.searchProvinceCode ', this.searchProvinceCode, ' this.searchCity ', this.searchCity);

						// console.log('location', location);
						// const position = new google.maps.LatLng(location);
						this.searchPosition(position, viewport).finally(() => this.busyFind = false, this.model.address = this.model.address, this.countSearch++ );
					} else {
						this.$timeout(() => {
							const message = 'Geocode was not successful for the following reason: ' + status;
							// console.log('StoreLocatorCtrl.onSubmit.error', message);
							this.error = { message };
							this.busyFind = false;
						});
					}
				});
			}
		}, 500);
	}

	setInfoWindow(position, mode) {
		if (SHOW_INFO_WINDOW) {
			const infoWindow = this.infoWindow || new google.maps.InfoWindow();
			this.infoWindow = infoWindow;
			infoWindow.setPosition(position);
			switch (mode) {
				case 1:
					infoWindow.setContent('Current location');
					break;
				case 2:
					infoWindow.setContent('Error: The Geolocation service failed.');
					break;
				default:
					infoWindow.setContent('Error: Your browser doesn\'t support geolocation.');
			}
			infoWindow.open(this.map);
		}
	}

	setMarkerWindow(position, content) {
		if (position) {
			const markerWindow = this.markerWindow || new google.maps.InfoWindow({
				pixelOffset: new google.maps.Size(0, -35)
			});
			this.markerWindow = markerWindow;
			markerWindow.setPosition(position);
			markerWindow.setContent(content);
			markerWindow.open(this.map);
		} else {
			this.closeMarkerWindow();
		}
	}

	closeMarkerWindow() {
		if (this.markerWindow) {
			this.markerWindow.close();
		}
	}

	getWorldBounds() {
		return new google.maps.LatLngBounds(
			new google.maps.LatLng(61, 60),
			new google.maps.LatLng(-37, -92)
		);
	}

	getItalyBounds() {
		return new google.maps.LatLngBounds(
			new google.maps.LatLng(46.4657567, 5.233972),
			new google.maps.LatLng(36.8257773, 18.963541)
		);
	}

	scrollToStore(store) {
		const storesNode = document.querySelector('.section--stores');
		const storeNode = document.querySelector(`#store-${store.id}`);
		// console.log(storesNode, storeNode);
		storesNode.scrollTo(0, storeNode.offsetTop);
	}

	onScroll(event) {
		if (this.visibleItems && this.visibleItems.length !== this.maxItems) {
			if (event.rect.top + event.rect.height < event.windowRect.bottom) {
				if (!this.busy && this.maxItems < this.stores.length) {
					this.$timeout(() => {
						this.busy = true;
						this.$timeout(() => {
							this.maxItems += ITEMS_PER_PAGE;
							this.visibleItems = this.getStoresByViewport();
							this.busy = false;
							// console.log(this.visibleItems.length);
						}, 1000);
					}, 0);
				}
			}
		}
	}

	getStoresByCountry(countryCode) {
		let stores = [];

		if (this.stores) {
			for (let i = 0; i < this.stores.length; i++) {
				if (this.stores[i].countryCode === countryCode) {
					stores.push(this.stores[i]);
				}
			}
		}

		return stores;
	}

	getAgentsByInfo(countryCode) {
		let agents = [];
		let provinceCode = this.searchProvinceCode !== '' ? this.searchProvinceCode : this.stores.length > 0 && this.stores[1].province ? this.stores[1].province : ''; // level_2 - provincia
		let cityCode = this.searchCity !== '' ? this.searchCity : this.stores.length > 0 && this.stores[1].city ? this.stores[1].city : ''; // level_3 - città
		let areaCode = this.searchArea !== '' ? this.searchArea : this.stores.length > 0 && this.stores[1].city ? this.stores[1].city : ''; // level_1 - area
		if (countryCode !== '') {
			// solo i mercati "sbloccati" per gli agenti
			if (agentsEnabledCountry.indexOf(countryCode) !== -1) {
				//facendo così, mentre per l'Italia riceviamo un provinceCode del tipo 'RM' (indipendente dalla lingua), per la Francia ci viene restituito 'Parigi' o 'Paris'
				//a seconda della lingua quindi per trovare il match dobbiamo registrare più "coperture" per gli agenti, in tutte le lingue
				agents = _.filter(this.agents, function (o) {
					return o.countries_detail !== null &&
						o.countries_detail.indexOf(countryCode) !== -1 &&
						(
							(o.administrative_area_level_2_detail !== null &&
								o.administrative_area_level_2_detail.map(function (el) {
									return el.trim();
								}).indexOf(provinceCode.trim()) !== -1
							) ||
							// controllo anche se google mi ha passato l'informazione che cerco (copertura agente administrative_level_2)
							// in un altro campo: administrative_level_1, administrative_level_3... Fondamentale per la Germania!
							(o.administrative_area_level_2_detail !== null &&
								o.administrative_area_level_2_detail.map(function (el) {
									return el.trim();
								}).indexOf(cityCode.trim()) !== -1
							) ||
							(o.administrative_area_level_2_detail !== null &&
								o.administrative_area_level_2_detail.map(function (el) {
									return el.trim();
								}).indexOf(areaCode.trim()) !== -1
							)
						)
						;
				});
			}
			else
			{
				agents = _.filter(this.agents, function (o) {
					return o.countries_detail !== null &&
						o.countries_detail.indexOf(countryCode) !== -1;
				});
			}
		}
		//non mettiamo il marker per l'agente
		//agents.forEach((agent) => {
		//	const geocoder = this.geocoder || new google.maps.Geocoder();
		//	this.geocoder = geocoder;
		//	geocoder.geocode({ address: agent.administrative_area_level_1 }, (results, status) => {
		//		if (status == 'OK') {
		//			agent.latitude = results[0].geometry.location.lat();
		//			agent.longitude = results[0].geometry.location.lng();
		//		} else {
		//			agent.latitude = null;
		//			agent.longitude = null;
		//		}
		//	});
		//});
		agents = _.sortBy(agents, o => o.order);
		return agents;
	}

	countryContainsStores(countryCode) {
		if (this.stores) {
			for (let i = 0; i < this.stores.length; i++) {
				if (this.stores[i].countryCode === countryCode) {
					return true;
				}
			}
		}

		return false;
	}

	boundsContainsStores(bounds) {
		if (this.stores) {
			for (let i = 0; i < this.stores.length; i++) {
				if (this.stores[i].marker && bounds.contains(this.stores[i].marker.getPosition())) {
					return true;
				}
			}
		}

		return false;
	}

	getStoresByViewport() {
		let visibleItems = [];

		if (this.stores) {
			for (let i = 0; i < this.stores.length; i++) {
				if (this.stores[i].marker && this.map.getBounds().contains(this.stores[i].marker.getPosition())) {
					visibleItems.push(this.stores[i]);
				}
			}
		}

		visibleItems = visibleItems.sort((a, b) => {
			//if (a.type === b.type) {
				return a.distance - b.distance;
			//} else {
			//	return a.type - b.type;
			//}
		});

		// Se Belgio, mostro tutte le cards degli store oltre ai pin, non solo 3
		if (this.searchCountry === 'BE') {
			return visibleItems;
		}

		return visibleItems.slice(0, 3);
	}

}

StoreLocatorCtrl.$inject = ['$scope', '$timeout', 'DomService', 'ApiService'];

export default StoreLocatorCtrl;
